import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import Vue2Filters from "vue2-filters";
import VueMoment from "vue-moment";
import vuetify from "./plugins/vuetify";

import DefaultLayout from "@/layouts/Default";
import CenteredLayout from "@/layouts/Centered";
import InnerPageLayout from "@/layouts/InnerPage";

import BrandLogo from "@/components/BrandLogo";
import BrandLogoLoader from "@/components/BrandLogoLoader";

import * as VueGoogleMaps from 'vue2-google-maps';

import "./registerServiceWorker"

import {
  VueMaskDirective
} from 'v-mask'
Vue.directive('mask', VueMaskDirective);

Vue.use(VueMoment);
Vue.use(Vue2Filters);

Vue.component("default-layout", DefaultLayout);
Vue.component("centered-layout", CenteredLayout);
Vue.component("inner-page-layout", InnerPageLayout);

Vue.component("BrandLogo", BrandLogo);
Vue.component("BrandLogoLoader", BrandLogoLoader);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDG7_6lxN0J7dEDP1maUwBzoOlWd0wqpFQ',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
  installComponents: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,

  render: h => h(App),

  created() {
    window.addEventListener("resize", () => {
      store.dispatch("appshell/updateClientWindowSize", {
        width: window.innerWidth,
        height: window.innerHeight
      });
    });
    window.addEventListener("offline", () => {
      store.dispatch("appshell/updateNetworkStatus", false);
    });
    window.addEventListener("online", () => {
      store.dispatch("appshell/updateNetworkStatus", true);
    });
  }

}).$mount("#app");